// models
import { NewContractIAImportProcess, ContractIAImportProcess } from '../../models/Entities/Contracts/ContractIAImportProcess';
import { ErrorType } from '../../models/HttpError';

// Create IA import process
export const CONTRACT_IAIMPORT_CREATE_REQUEST = 'CONTRACT_IAIMPORT_CREATE_REQUEST';
export const CONTRACT_IAIMPORT_CREATE_SUCCESS = 'CONTRACT_IAIMPORT_CREATE_SUCCESS';
export const CONTRACT_IAIMPORT_CREATE_FAILURE = 'CONTRACT_IAIMPORT_CREATE_FAILURE';

export interface ContractIAImportCreateRequestAction {
	type: typeof CONTRACT_IAIMPORT_CREATE_REQUEST;
	newProcess: NewContractIAImportProcess;
}

export interface ContractIAImportCreateSuccessAction {
	type: typeof CONTRACT_IAIMPORT_CREATE_SUCCESS;
	process: ContractIAImportProcess;
}

export interface ContractIAImportCreateFailureAction {
	type: typeof CONTRACT_IAIMPORT_CREATE_FAILURE;
	error: ErrorType;
}

// Get last IA import process for a contract
export const CONTRACT_IAIMPORT_GETLAST_REQUEST = 'CONTRACT_IAIMPORT_GETLAST_REQUEST';
export const CONTRACT_IAIMPORT_GETLAST_SUCCESS = 'CONTRACT_IAIMPORT_GETLAST_SUCCESS';
export const CONTRACT_IAIMPORT_GETLAST_FAILURE = 'CONTRACT_IAIMPORT_GETLAST_FAILURE';

export interface ContractIAImportGetLastRequestAction {
	type: typeof CONTRACT_IAIMPORT_GETLAST_REQUEST;
	contractId: number;
}

export interface ContractIAImportGetLastSuccessAction {
	type: typeof CONTRACT_IAIMPORT_GETLAST_SUCCESS;
	contractId: number;
	process: ContractIAImportProcess | null;
}

export interface ContractIAImportGetLastFailureAction {
	type: typeof CONTRACT_IAIMPORT_GETLAST_FAILURE;
	contractId: number;
	error: ErrorType;
}

